
const _ = require('lodash');

const cuid = require('cuid');

const SettlementSelectModal = require('settlement-select-modal');


class SelectSettlementTipModel {
	constructor (params) {
		params = _.defaults({}, params, {
			// where selected settlement is written
			value: undefined,

			// arguments for `SettlementSelectModal`
			title: undefined,
			settlementsDataset: undefined,
			settlementsMap: undefined,
			valueType: undefined,
		});

		this._params = params;

		// HACK
		this._titleId = cuid();
		this._titleSelector = '#' + this._titleId;

		this._selectSettlementCtrl = new SettlementSelectModal(
			_.pick(params,
				'settlementsDataset',
				'settlementsMap',
				'title',
				'valueType'
			)
		);
	}

	_openModalClick () {
		this._selectSettlementCtrl.promise().then((selectedSettlementValue) => {
			if (!selectedSettlementValue) {
				return;
			}
			this._params.value(selectedSettlementValue);
		}).done();
	}
}

module.exports = SelectSettlementTipModel;

